module.exports = __webpack_public_path__ + "img/9788931006476.07e177ad.jpg";